import declare from "dojo/_base/declare";
import csi from "csi/main";
import Widget from "csi/table/Widget";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import { QueryLevel } from "csi/view/_query/Level";

const ColorsByColorPaletteController = declare(Widget, {
	selectedPalette: csi.EMPTY_URL,

	/**
	 * @override
	 * Add filter to get the results for selected Palette.
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		const { selectedPalette } = this;

		if (xml.isValidURL(selectedPalette)) {
			ql.serverQuery = new Query().RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, selectedPalette);
		}
	},
});

export = ColorsByColorPaletteController;